import React, { Component, useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { EditorState, Modifier, SelectionState } from 'draft-js';
import { Tooltip, OverlayTrigger, Modal, Button } from 'react-bootstrap';
import { 
  map, last, indexOf, filter, trim, difference, each, reduce, sortBy, toLower,
  startsWith, endsWith, trimEnd, upperCase, startCase, trimStart, replace,
} from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styles from './styles.css';

const TOKEN_PREFIX = 'Submitted';
const TOKEN_SUFFIX = 'Contacts';
const TOKEN_SEPARATOR = ':';
const STATUS_SEPARATOR = ',';

const ALL_STATUS = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'SUCCEEDED', label: 'Succeeded' },
  { value: 'UNSUBSCRIBED', label: 'Unsubscribed' },
  { value: 'COMPLETED', label: 'Complete' },
  { value: 'PAUSED', label: 'Paused' },
  { value: 'BOUNCED', label: 'Bounced' },
  { value: 'DISQUALIFIED', label: 'Disqualified' },
  { value: 'TERMINATED', label: 'Terminated' },
];

/*
valid tokens:
{SubmittedContacts}
{SubmittedContacts:ACTIVE}
{SubmittedContacts:ACTIVE,BOUNCED}
{SubmittedActiveContacts}
{SubmittedTerminatedContacts}
etc...
*/

const mutatedReorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};

export function contactListHandleStrategy(contentBlock, callback) {
  const input = contentBlock.getText();
  const allStatus = map(ALL_STATUS, 'value');
  // const tokenRegex = new RegExp(`{${TOKEN_PREFIX}${TOKEN_SUFFIX}(${TOKEN_SEPARATOR}(${allStatus.join('|')})(${STATUS_SEPARATOR}(${allStatus.join('|')}))*)?}|${map(allStatus, (s) => { return `{${TOKEN_PREFIX}${startCase(toLower(s))}${TOKEN_SUFFIX}}`; }).join('|')}`, 'gi');
  const tokenRegex = new RegExp(`{${TOKEN_PREFIX}${TOKEN_SUFFIX}(${TOKEN_SEPARATOR}(${allStatus.join('|')})(${STATUS_SEPARATOR}(${allStatus.join('|')}))*)?}`, 'gi');
  let matchArr = tokenRegex.exec(input);

  while (matchArr !== null) {
    const [token] = matchArr;
    callback(matchArr.index, matchArr.index + token.length);
    matchArr = tokenRegex.exec(input);
  }
};

let __currentValue = '';


function getNewEditorState(editorState, newContactToken) {
  const selectionState = editorState.getSelection();
  const anchorKey = selectionState.getAnchorKey();
  const currentContent = editorState.getCurrentContent();
  const currentContentBlock = currentContent.getBlockForKey(anchorKey);
  const contentState = editorState.getCurrentContent();

  if (!currentContentBlock) {
    return;
  }

  const start = selectionState.getStartOffset();

  let lastStart = null;
  let lastEnd = null;
  contactListHandleStrategy(currentContentBlock, (s, e) => {
    if (s <= start) {
      lastStart = s;
      lastEnd = e;
    }
  });

  const updatedSelection = new SelectionState({
    anchorKey,
    anchorOffset: lastStart,
    focusOffset: lastEnd,
    focusKey: selectionState.getFocusKey(),
  });

  const modifiedContent = Modifier.replaceText(
    contentState,
    updatedSelection,
    newContactToken,
    editorState.getCurrentInlineStyle(),
    // entityKey?: ?string
  );

  return EditorState.push(editorState, modifiedContent);
}


export const ContactTokenModal = (props) => {
  const { open } = props;
  const [currentList, setCurrentList] = useState([...ALL_STATUS]);

  function getFullList() {
    return filter(ALL_STATUS, (s) => {
      return s.value !== 'TERMINATED';
    });
  }

  function valueToObjectList(values, select = false) {
    const newList = sortBy(currentList, (status) => {
      const i = indexOf(values, status.value);
      return i < 0 ? ALL_STATUS.length + 100 : i;
    });
    if (select) {
      each(newList, (s) => {
        s.selected = indexOf(values, s.value) >= 0;
      });
    }
    return newList;
  }

  useEffect(() => {
    if (open) {
      // prepare selected values
      const trimmedText = trim(__currentValue, '{}');
      if (trimmedText === `${TOKEN_PREFIX}${TOKEN_SUFFIX}`) {
        setCurrentList(valueToObjectList(map(getFullList(), 'value'), true));
      } else {
        if (startsWith(trimmedText, `${TOKEN_PREFIX}${TOKEN_SUFFIX}`)) {
          const currentStatus = last(trimmedText.split(TOKEN_SEPARATOR)).split(STATUS_SEPARATOR);
          setCurrentList(valueToObjectList(currentStatus, true));
        } else if (endsWith(trimmedText, TOKEN_SUFFIX)) {
          // const currentStatus = [upperCase(replace(trimmedText, new RegExp(`^${TOKEN_PREFIX}|${TOKEN_SUFFIX}$`, 'gi'), ''))];
          // setCurrentList(valueToObjectList(currentStatus, true));
        }
      }
    }
  }, [open, __currentValue]);


  function handleCloseModal() {
    props.onClose();
  }

  function toggleValue(v) {
    const newList = reduce(currentList, (items, s) => {
      if (s.value === v) {
        s.selected = s.selected !== true;
      }
      items.push({
        ...s,
      });
      return items;
    }, []);
    setCurrentList(newList);
  }



  function updateValues() {
    const selectedValues = map(filter(currentList, (l) => { return l.selected === true; }), 'value');
    const isAll = selectedValues.length === 0 || difference(map(getFullList(), 'value'), selectedValues).length === 0;
    const replacer = (editorState) => {
      return getNewEditorState(editorState, newToken);
    };
    let newToken = null;
    if (isAll) {
      newToken = `{${TOKEN_PREFIX}${TOKEN_SUFFIX}}`;
    // } else if (selectedValues.length === 1) {
      // newToken = `{${TOKEN_PREFIX}${startCase(toLower(selectedValues[0]))}${TOKEN_SUFFIX}}`;
    } else {
      newToken = `{${TOKEN_PREFIX}${TOKEN_SUFFIX}${TOKEN_SEPARATOR}${selectedValues.join(STATUS_SEPARATOR)}}`;
    }
    if (newToken) {
      props.onChange(newToken, replacer);
    }
    
    handleCloseModal();
  }

  function onDragEnd(result) {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    const list = map(currentList, 'value');
    mutatedReorder(
      list,
      source.index,
      destination.index,
    );
    setCurrentList(valueToObjectList(list));
  }


  return (
    <Modal key="modal" show={open} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <h4>Edit Contact List</h4>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.valueList}>
          <p>Select contacts with status to include in the list:</p>
          <DragDropContext onDragEnd={onDragEnd}>
            <Fragment>
              <table className="table table-striped table-hover">
                <Droppable droppableId="value-list" ignoreContainerClipping>
                  {(provided, snapshot) => (
                    <tbody
                     ref={provided.innerRef}
                     className={snapshot.isDraggingOver ? styles.draggingOver : null}
                    >
                      {currentList.map((status, i) => {
                        const active = status.selected === true;
                        let faName = 'arrows-v';
                        if (i === 0) {
                          faName = 'long-arrow-down';
                        } else if ( i === ALL_STATUS.length - 1) {
                          faName = 'long-arrow-up'
                        }
                        return (
                          <Draggable key={status.value} draggableId={status.value} index={i}>
                            {(pv, ss) => {
                              return (
                                <tr
                                  key={status.value} 
                                  ref={pv.innerRef}
                                  {...pv.draggableProps}
                                  className={`${ss.isDragging ? styles.dragging : ''}`}
                                  style={pv.draggableProps.style}
                                >
                                  <td width="20" {...pv.dragHandleProps}>
                                    <Fa name={faName} />
                                  </td>
                                  <td 
                                    width="20"
                                    onClick={() => { toggleValue(status.value) }} 
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <Fa name={active ? 'check-square' : 'square-o'} />
                                  </td>
                                  <td>
                                    {active && <strong>{status.label}</strong>}
                                    {!active && <span>{status.label}</span>}
                                  </td>
                                </tr>
                              );
                            }}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </tbody>
                  )}
                </Droppable>
              </table>
            </Fragment>
          </DragDropContext>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="clearfix">
          <Button className="pull-left" bsStyle="default" onClick={handleCloseModal}>Cancel</Button>
          <Button className="pull-right" bsStyle="primary" onClick={updateValues}>Update</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}




ContactTokenModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
};
ContactTokenModal.defaultProps = {
  open: false,
  onClose: () => {},
  onChange: () => {},
};

export const ContactListToken = (props) => {
  const { decoratedText, children } = props;

  function handleClick(e) {
    e.preventDefault();
    __currentValue = decoratedText;
    props.onClick();
  }


  return (
    <span {...props} onClick={handleClick} className={`${styles.segmented} ${__currentValue && __currentValue !== decoratedText ? 'animated flash' : ''}`}>
      {children}
    </span>
  );
};

ContactListToken.propTypes = {
  offsetKey: PropTypes.string,
  children: PropTypes.node,
  decoratedText: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
ContactListToken.defaultProps = {
  offsetKey: null,
  children: null,
  onClick: () => {},
};